// extracted by mini-css-extract-plugin
export default {"title":"Task_title__9gNlf"};